"use client";

import { useCallback, useEffect, useState } from "react";
import { getActiveCart } from "../slice/cart-slice";
import { useAppDispatch, useAppSelector } from "../slice/hooks";
import StoreBox from "./store-box";
import CartModal from "./cart-modal";
import Progress from "./progress";

import {
  setAccessPoint,
  setAccessPointId,
  setAccessPoints,
  setOrganisation,
} from "../slice/accessOrg-slice";

const CartPage = (props) => {
  const {
    closeModal,
    showProduct,
    activateBackButton,
    modal,
    checkoutState,
    setCheckoutState,
    showProgress,
    setShowProgress,
    navLocation,
    cart,
    organisation,
    accessPoint,
    storePath,
    urlData,
  } = props;

  const dispatch = useAppDispatch();

  console.log({ cart });

  useEffect(() => {
    if (!urlData) return;
    // Restore organisation context from snapshot
    if (urlData.organisation) {
      dispatch(setOrganisation(urlData.organisation));
    }

    if (urlData.accessPointId) {
      dispatch(setAccessPointId(urlData.accessPointId));
    }

    if (urlData.accessPoint) {
      dispatch(setAccessPoint(urlData.accessPoint));
    }

    if (Array.isArray(urlData.accessPoints)) {
      dispatch(setAccessPoints(urlData.accessPoints));
    }
  }, [urlData]);

  const [isPageMode, setIsPageMode] = useState(modal ? false : true);
  const [publicUser, setPublicUser] = useState(null);

  const handleActivateBackButton = (show, onClickBackButton = null) => {
    activateBackButton?.(show, onClickBackButton);
    setShowProgress(show);
  };

  const handleLocationChange = useCallback(() => {}, []);
  return (
    <StoreBox
      {...props}
      handleLocationChange={handleLocationChange}
      isPageMode={isPageMode}
    >
      <div className="cart-container">
        <div className="cart-div">
          <div className="auth-form-header ">
            {showProgress && (
              <div className="auth-form-header">
                <Progress
                  checkoutState={checkoutState}
                  setCheckoutState={setCheckoutState}
                  accessPoint={accessPoint}
                  publicUser={publicUser}
                />
              </div>
            )}
          </div>

          <CartModal
            cart={cart}
            showProduct={showProduct}
            modal={modal}
            closeModal={closeModal}
            accessPoint={accessPoint}
            activateBackButton={handleActivateBackButton}
            checkoutState={checkoutState}
            setCheckoutState={setCheckoutState}
            publicUser={publicUser}
            setPublicUser={setPublicUser}
            isPageMode={isPageMode}
            storePath={storePath}
            organisation={organisation}
            navLocation={navLocation}
          />
        </div>
      </div>
    </StoreBox>
  );
};

export default CartPage;
